"use client"

import { Button } from '@/components/atoms';
import { SellerReview } from '@/components/molecules';
import { SingleProductReview } from '@/types/product';
import { useTranslate } from '@tolgee/react';

export const ProductDetailsSellerReviews = ({
  reviews,
}: {
  reviews: SingleProductReview[];
}) => {
  const { t } = useTranslate();
  return (
    <div className='p-4 border rounded-sm'>
      <div className='flex justify-between items-center mb-5'>
        <h4 className='uppercase heading-sm'>
          {t("product_details.seller_reviews_heading")}
        </h4>
        <Button
          variant='tonal'
          className='uppercase label-md font-400'
        >
          {t("product_details.see_more")}
        </Button>
      </div>
      {reviews.map((review) => (
        <SellerReview key={review.id} review={review} />
      ))}
    </div>
  );
};
